

























import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class TwoForOneIcon extends Vue {
  @Prop({ default: '32' }) readonly width?: string;
  @Prop({ default: '32' }) readonly height?: string;
  @Prop({ default: 'currentColor' }) readonly color?: string;
}
